import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LangProvider } from "@/context/LangContext";
import { CartProvider } from "@/context/CartContext";
import SmoothScroll from "@/components/SmoothScroll";
import ScrollToTop from "@/components/ScrollToTop";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Movement from "@/pages/Movement";
import CreatorsPage from "@/pages/CreatorsPage";
import CreatorDetail from "@/pages/CreatorDetail";
import Checkout from "@/pages/Checkout";
import Lookbook from "@/pages/Lookbook";
import BundleBuilder from "@/pages/BundleBuilder";

function App() {
  return (
    <div className="App">
      <LangProvider>
        <CartProvider>
          <BrowserRouter>
            <SmoothScroll>
              <ScrollToTop />
              <Header />
              <CartDrawer />
              <main>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/shop" element={<Shop />} />
                  <Route path="/product/:id" element={<ProductDetail />} />
                  <Route path="/movement" element={<Movement />} />
                  <Route path="/creators" element={<CreatorsPage />} />
                  <Route path="/creator/:slug" element={<CreatorDetail />} />
                  <Route path="/lookbook" element={<Lookbook />} />
                  <Route path="/bundle" element={<BundleBuilder />} />
                  <Route path="/checkout" element={<Checkout />} />
                  <Route path="*" element={<Home />} />
                </Routes>
              </main>
              <Footer />
              <Toaster position="bottom-center" />
            </SmoothScroll>
          </BrowserRouter>
        </CartProvider>
      </LangProvider>
    </div>
  );
}

export default App;
